import { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import DrawerSendEmail from '../common/DrawerSendEmail.component';
import { fetchAPI } from '../../api/request';
import { API } from '../../module/mexal/index';

const AgencyDrawerSendEmail = ({ conf, data, ...rest }) => {
  const { jwt } = useSelector((state) => state.login);
  const [mexalData, setMexalData] = useState({});

  const fetchMexalCustomer = useCallback(() => {
    if (data?.mexal_codice && jwt) {
      fetchAPI(
        API.mexalCustomerByMexalID,
        { id: data.mexal_codice }, '', {}, jwt
      )
        .then((response) => {
          const customer = response?.data?.attributes || response?.data || response;
          if (customer) {
            setMexalData({
              invoice_entity: customer.invoice_entity || '',
              mexal_codice: customer.mexal_code || data.mexal_codice,
              mexal_ragione_sociale: customer.mexal_ragione_sociale || '',
              mexal_nome: customer.mexal_nome || '',
              mexal_cognome: customer.mexal_cognome || '',
              mexal_indirizzo: customer.mexal_indirizzo || '',
              mexal_cap: customer.mexal_cap || '',
              mexal_localita: customer.mexal_localita || '',
              mexal_provincia: customer.mexal_provincia || '',
              mexal_tp_nazionalita: customer.mexal_tp_nazionalita || '',
              mexal_partita_iva: customer.mexal_partita_iva || '',
              mexal_codice_fiscale: customer.mexal_codice_fiscale || '',
              mexal_cod_paese: customer.mexal_cod_paese || '',
              mexal_pec: customer.mexal_pec || '',
              mexal_codice_sdi: customer.mexal_codice_sdi || '',
              mexal_denominazione: customer.mexal_denominazione || '',
            });
          }
        })
        .catch(() => {});
    }
    // eslint-disable-next-line
  }, [data?.mexal_codice, jwt]);

  const resolvedConf = useMemo(() => ({
    ...conf,
    fields: conf.getFields ? conf.getFields(mexalData.invoice_entity) : conf.fields,
  }), [conf, mexalData.invoice_entity]);

  const mergedData = useMemo(() => ({
    ...data,
    ...mexalData,
  }), [data, mexalData]);

  const transformSubmitValues = useCallback((values) => ({
    billingData: {
      invoice_entity: values.invoice_entity || '',
      mexal_codice: values.mexal_codice || '',
      mexal_ragione_sociale: values.mexal_ragione_sociale || '',
      mexal_nome: values.mexal_nome || '',
      mexal_cognome: values.mexal_cognome || '',
      mexal_indirizzo: values.mexal_indirizzo || '',
      mexal_cap: values.mexal_cap || '',
      mexal_localita: values.mexal_localita || '',
      mexal_provincia: values.mexal_provincia || '',
      mexal_tp_nazionalita: values.mexal_tp_nazionalita || '',
      mexal_partita_iva: values.mexal_partita_iva || '',
      mexal_codice_fiscale: values.mexal_codice_fiscale || '',
      mexal_cod_paese: values.mexal_cod_paese || '',
      mexal_pec: values.mexal_pec || '',
      mexal_codice_sdi: values.mexal_codice_sdi || '',
      mexal_denominazione: values.mexal_denominazione || '',
    },
  }), []);

  return (
    <DrawerSendEmail
      {...rest}
      conf={resolvedConf}
      data={mergedData}
      onOpen={fetchMexalCustomer}
      transformSubmitValues={transformSubmitValues}
    />
  );
};

export default AgencyDrawerSendEmail;
